// client/src/routes/app/properties/$propertyId/utilities.tsx — SCR-PROP-003 tab „Contoare"
// (D-2840).
//
// SCR-UTIL-001's list with the property pinned: the apartment's utility services and meters,
// with their last index, the active and the retired ones. `Operations.Read`, as the list's own
// route.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { UtilityList } from '@/features/utilities/UtilityList';
import { utilitySearchSchema, type UtilitySearch } from '@/features/utilities/search';

export const Route = createFileRoute('/app/properties/$propertyId/utilities')({
  validateSearch: utilitySearchSchema,
  component: UtilityListTab,
});

function UtilityListTab() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Operations.Read">
      <UtilityList
        pinnedPropertyId={propertyId}
        search={search}
        onSearchChange={(next: (previous: UtilitySearch) => UtilitySearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
